import React from 'react';
import Select from 'react-select';
import ReactTooltip from 'react-tooltip'
import {
  canEditOpeningBalanceFields,
  formatOpeningBalanceDisplayDate,
  getOpeningBalanceMinDate,
  shouldShowOpeningBalanceDateField,
} from '../../utils/openingBalanceDate'
import OpeningBalanceUnlockButton from '../../utils/OpeningBalanceUnlockButton';
import { Link, useLocation } from "react-router-dom";
const VendorModal = ({ prevNonNumericalWithDec,preventNonNumericalInput,isShowing,setProduct, hide,success,double, handleSubmit,list, dropdownData,handleSelect, handleInput,inputValues,selected_options, errors,list_data, handleInputs,stat_operation,canEditOpeningBalance,onUnlockOpeningBalance,isOwnerRole }) => {
  const canEditOpeningFields = canEditOpeningBalanceFields({
    statOperation: stat_operation,
    openingBalanceUnlocked: canEditOpeningBalance,
  });
  const showOpeningBalanceFields = stat_operation !== "Yes" || canEditOpeningFields;
  const showOpeningBalanceDateField = shouldShowOpeningBalanceDateField({
    statOperation: stat_operation,
    openingBalanceUnlocked: canEditOpeningBalance,
  });
  const formatOpeningBalanceDisplay = (amount, debitCredit) => {
    const numericAmount = Number(amount || 0);
    const formattedAmount = numericAmount.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return debitCredit === "Dr" ? `(${formattedAmount})` : formattedAmount;
  };
  const location_details = useLocation()
  return (
  <React.Fragment>


<div className="modal-overlay"/>
    <div className="modal-wrapper" aria-modal aria-hidden tabIndex={-1} role="dialog">
      <div className="modal">
        <div className="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{inputValues["id"] ? "Edit Vendor Configuration" : "Vendor Configuration"}</h5>
          <div className="d-flex align-items-center gap-2">
            <OpeningBalanceUnlockButton
              statOperation={stat_operation}
              unlocked={Boolean(canEditOpeningBalance)}
              canUnlock={isOwnerRole}
              onUnlock={onUnlockOpeningBalance}
            />
          <button type="button" className="modal-close-button" data-dismiss="modal" aria-label="Close" onClick={hide}>
            <span aria-hidden="true">&times;</span>
          </button>
          </div>
        </div>
        <div className="form-group">
          <label>Name <sup class="star">*</sup></label>
<input type="text" className="form-control " name="name" value={inputValues["name"]} onChange={handleInputs}  readOnly={inputValues["ob_is_dayclose"]}/>
<div className="errorMsg">{errors.name}</div>
</div>
<div className="form-group">
  <label>Address</label>
  <input type="text" className="form-control" name="address" value={inputValues["address"]} onChange={handleInputs}  />
  </div>
  <div className="form-group">
    <label>Phone</label>
    <input type="number" className="form-control hide-arrow ph_no" name="phone" onKeyPress={(event)=>prevNonNumericalWithDec(event,event.target.value)} value={inputValues["phone"]} id={"phone"} onChange={handleInputs}  />
    <div className="errorMsg">{errors.phone}</div>
    </div>
    <div className="form-group">
      <label>Email</label>
      <input type="text" className="form-control" name="email" value={inputValues["email"]} onChange={handleInputs} />
      <div className="errorMsg">{errors.email}</div>
      </div>
      <div className="form-group">
        <label>Credit Period in Days</label>
        <input type="number" className="form-control" onKeyPress={(event)=>prevNonNumericalWithDec(event,event.target.value)} name="credit_period" min={1} max={100} value={inputValues["credit_period"]} onChange={handleInputs} />
        <div className="errorMsg">{errors.credit_period}</div>
         </div>
        <div className="form-group">
        <label>Product Name</label>
        <Select   
     isMulti
       value={selected_options}
      //  value={inputValue.product_name}
       onChange={handleSelect}
  //    onBlur={()=>setProduct()}
      //  onChange={handleSelect}
       options={list_data}
      > 
      </Select>
      <Link to={location => ({ ...location, backpage: location_details.pathname, pathname: "/products/products" })} class="link-text"><a href="">Click here to add new products</a></Link>
        </div>
      <div className="row">
      {(showOpeningBalanceFields) ?
           <div className="col-md-8 ">
            
              <div className="form-group">
                  <label>Opening Balance<sup class="star">*</sup></label>
                  <input type="number" className="form-control hide-arrow" onKeyPress={(event)=>preventNonNumericalInput(event,event.target.value)} name="opening_balance" id={"open"} value={inputValues["opening_balance"]} onChange={ handleInput} readOnly={!canEditOpeningFields} />
                  <div className="errorMsg">{errors.opening_balance}</div>
                  <div className="errorMsg">{errors.debit_credit}</div>
                  <span id="words" class="amount-words"></span>
              </div>
             
          </div>  
          :""} 
{(showOpeningBalanceFields) ?
          <div className="col-md-4 mt-4 d-flex">
              <div className="form-check col-sm pr-0">
                  {/* <input className="form-check-input" type="radio"  name="debit_credit" value="Cr" onClick={ handleInputs} checked={inputValues.debit_credit === 'Cr'} /> */}
                  <input className="form-check-input" type="radio" data-tip='Need to pay the party'  id="exampleRadios1"  name="debit_credit" value="Cr" onClick={ handleInputs} checked={inputValues.debit_credit === 'Cr'} disabled={!canEditOpeningFields} />
                  <label className="form-check-label col-form-label" for="exampleRadios1">   Credit 
                  </label>
                  <ReactTooltip />
              </div>
              
              <div className="form-check col-sm pr-0">
              <input className="form-check-input" type="radio" data-tip='Party to pay us'  id="exampleRadios1"  name="debit_credit" value="Dr" onClick={ handleInputs} checked={inputValues.debit_credit === 'Dr'} disabled={!canEditOpeningFields} />
               {/* <input className="form-check-input" type="radio" name="debit_credit"  value="Dr" onClick={ handleInputs} checked={inputValues.debit_credit === 'Dr'} /> */}
                  <label className="form-check-label col-form-label" for="exampleRadios1">  Debit
              
                  </label>
                  <ReactTooltip />
              </div>
         
          </div>
          :""}
          {(showOpeningBalanceDateField) ?
          <div className="form-group mb-3">
            <label>Opening Balance Date</label>
            <input
              type="date"
              className="form-control"
              name="ac_date"
              value={inputValues.ac_date || ""}
              min={getOpeningBalanceMinDate()}
              onChange={handleInputs}
              readOnly={!canEditOpeningFields}
              disabled={!canEditOpeningFields}
            />
          </div>
          :""}
          
          

          
              

          {Array.isArray(inputValues?.opening_balance_edit_history) && inputValues.opening_balance_edit_history.length > 0 && (
            <div className="mt-3">
              <h6 className="mb-2">Opening Balance Edit History</h6>
              <div className="table-responsive">
                <table className="table table-sm table-bordered">
                  <thead>
                    <tr>
                      <th>Previous Value</th>
                      <th>Previous Date</th>
                      <th>New Value</th>
                      <th>New Date</th>
                      <th>Edited By</th>
                      <th>Edited At</th>
                    </tr>
                  </thead>
                  <tbody>
                    {inputValues.opening_balance_edit_history.map((log, idx) => (
                      <tr key={`ob-log-${idx}`}>
                        <td>{formatOpeningBalanceDisplay(log.previous_opening_balance, log.previous_debit_credit)}</td>
                        <td>{formatOpeningBalanceDisplayDate(log.previous_ac_date) || "—"}</td>
                        <td>{formatOpeningBalanceDisplay(log.new_opening_balance, log.new_debit_credit)}</td>
                        <td>{formatOpeningBalanceDisplayDate(log.new_ac_date) || "—"}</td>
                        <td>{log.edited_by || "Unknown"}</td>
                        <td>{log.edited_at ? new Date(log.edited_at).toLocaleString("en-IN") : "—"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <div class="modal-footer">
          {double===true ?    <button type="submit" class="btn btn-primary" onClick={handleSubmit}>Save Vendor</button> : <button type="submit" class="btn btn-primary"   disabled>Save Vendor</button>}
          </div>
                  
      </div>

  </div>
    </div>
</React.Fragment>
        );
      }
       export default VendorModal;